// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Cosmic Banking Styles
   ========================================== */

.banking-header {
  text-align: center;
  margin-bottom: 2rem;
}

.banking-tabs {
  display: flex;
  gap: 1rem;
  border-bottom: 1px solid var(--border-bento);
  margin-bottom: 3rem;
  overflow-x: auto;
  justify-content: center;
}

.banking-tabs button {
  padding: 1rem 2rem;
  background: none;
  border: none;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-muted);
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  font-family: var(--font-family);
}

.banking-tabs button:hover {
  color: #ffffff;
}

.banking-tabs button.active {
  color: var(--color-neon-cyan);
}

.banking-tabs button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--grad-cosmic);
  border-radius: 3px 3px 0 0;
}

/* Accounts Section */
.account-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.account-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.account-number {
  color: var(--text-muted);
  font-size: 0.9rem;
  background: rgba(0, 0, 0, 0.3);
  padding: 0.2rem 0.6rem;
  border-radius: var(--radius-pill);
}

.account-balance {
  font-size: 2.5rem;
  font-weight: 800;
  background: var(--grad-success);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1.5rem;
}

.account-actions {
  display: flex;
  gap: 1rem;
}

.action-btn {
  flex: 1 1;
  padding: 0.8rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border-bento);
  border-radius: var(--radius-pill);
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn.primary {
  background: var(--grad-cosmic);
  border: none;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.action-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(176, 38, 255, 0.4);
}

/* Transactions Section */
.transactions-filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.transactions-filters select {
  flex: 1 1;
  max-width: 250px;
}

.transactions-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.transaction-item {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border-bento);
  border-radius: var(--radius-bento-small);
  transition: all 0.3s ease;
}

.transaction-item:hover {
  border-color: var(--color-neon-purple);
  background: rgba(176, 38, 255, 0.05);
}

.transaction-date {
  width: 80px;
  color: var(--text-muted);
  font-weight: 600;
  font-size: 0.9rem;
}

.transaction-details {
  flex: 1 1;
}

.transaction-description {
  font-weight: 700;
  color: #ffffff;
}

.transaction-category {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.transaction-amount {
  font-weight: 800;
  font-size: 1.1rem;
}

.transaction-amount.positive {
  color: #10b981;
}

.transaction-amount.negative {
  color: #ffffff;
}

/* Transfer Section */
.transfer-init {
  text-align: center;
  padding: 3rem;
}

.transfer-btn {
  background: var(--grad-cosmic);
  color: #ffffff;
  border: none;
  padding: 1rem 2.5rem;
  border-radius: var(--radius-pill);
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 1.5rem;
  transition: all 0.3s ease;
}

.transfer-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-neon);
}

.transfer-form {
  max-width: 600px;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #ffffff;
  font-weight: 600;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
}

.cancel-btn {
  flex: 1 1;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border-bento);
  border-radius: var(--radius-pill);
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
}

.submit-btn {
  flex: 2 1;
  padding: 1rem;
  background: var(--grad-cosmic);
  border: none;
  border-radius: var(--radius-pill);
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Bank.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,eAAe;EACf,qCAAqC;EACrC,qCAAqC;EACrC,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,qCAAqC;EACrC,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* ==========================================\n   Kubersetu Cosmic Banking Styles\n   ========================================== */\n\n.banking-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.banking-tabs {\n  display: flex;\n  gap: 1rem;\n  border-bottom: 1px solid var(--border-bento);\n  margin-bottom: 3rem;\n  overflow-x: auto;\n  justify-content: center;\n}\n\n.banking-tabs button {\n  padding: 1rem 2rem;\n  background: none;\n  border: none;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n  font-family: var(--font-family);\n}\n\n.banking-tabs button:hover {\n  color: #ffffff;\n}\n\n.banking-tabs button.active {\n  color: var(--color-neon-cyan);\n}\n\n.banking-tabs button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background: var(--grad-cosmic);\n  border-radius: 3px 3px 0 0;\n}\n\n/* Accounts Section */\n.account-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.account-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.account-number {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  background: rgba(0, 0, 0, 0.3);\n  padding: 0.2rem 0.6rem;\n  border-radius: var(--radius-pill);\n}\n\n.account-balance {\n  font-size: 2.5rem;\n  font-weight: 800;\n  background: var(--grad-success);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 1.5rem;\n}\n\n.account-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.action-btn {\n  flex: 1;\n  padding: 0.8rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--border-bento);\n  border-radius: var(--radius-pill);\n  color: #ffffff;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.action-btn.primary {\n  background: var(--grad-cosmic);\n  border: none;\n}\n\n.action-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.action-btn.primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(176, 38, 255, 0.4);\n}\n\n/* Transactions Section */\n.transactions-filters {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.transactions-filters select {\n  flex: 1;\n  max-width: 250px;\n}\n\n.transactions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.transaction-item {\n  display: flex;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background: rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border-bento);\n  border-radius: var(--radius-bento-small);\n  transition: all 0.3s ease;\n}\n\n.transaction-item:hover {\n  border-color: var(--color-neon-purple);\n  background: rgba(176, 38, 255, 0.05);\n}\n\n.transaction-date {\n  width: 80px;\n  color: var(--text-muted);\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.transaction-details {\n  flex: 1;\n}\n\n.transaction-description {\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.transaction-category {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.transaction-amount {\n  font-weight: 800;\n  font-size: 1.1rem;\n}\n\n.transaction-amount.positive {\n  color: #10b981;\n}\n\n.transaction-amount.negative {\n  color: #ffffff;\n}\n\n/* Transfer Section */\n.transfer-init {\n  text-align: center;\n  padding: 3rem;\n}\n\n.transfer-btn {\n  background: var(--grad-cosmic);\n  color: #ffffff;\n  border: none;\n  padding: 1rem 2.5rem;\n  border-radius: var(--radius-pill);\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.transfer-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-neon);\n}\n\n.transfer-form {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.cancel-btn {\n  flex: 1;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--border-bento);\n  border-radius: var(--radius-pill);\n  color: #ffffff;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.submit-btn {\n  flex: 2;\n  padding: 1rem;\n  background: var(--grad-cosmic);\n  border: none;\n  border-radius: var(--radius-pill);\n  color: #ffffff;\n  font-weight: 700;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
